<template>
    <div  id="addTopic">
        <div class="app-inner">
      <div class="public-btn-small flex align-cen posta enposta" v-if="(!topicID && $route.query.type) || $route.query.id">
            <div class="public-btn-small-plan"  @click="$util.reback('/teacheManage/questionList')" style="margin-left:0">
                返回
            </div>
           <el-button type="primary" :loading="loading" class="public-btn-small-primary public-btn-small-load" style="margin-left:16px"
           @click="onSubmit()"
            >
             {{$route.query.id ? '修改' : '保存'}}
           </el-button>
            </div>
             <div class="edit-from">
            <div class="public-tit flex align-cen" v-if="!topicID && $route.query.type">
            <div class="public-tit-list">
                <i class="icon-al-file-plus"></i>  新增试题
            </div>
        </div>
    
        <div class="topic_container flex">
     <!-- 试题左边 -->
        <div class="topic_left"> 
            <div class="topic_left_tit">试题题型</div>
            <div class="topic_left_type_list" v-if="!$route.query.id && !topicID && ($route.query.type || PropType)">
                <div  v-for="(item,index) in radioList" :class="radio == item.id ? 'selected' : ''" class="publiRadio">
                     <el-radio v-model="radio" :label="item.id" @change="swichType">{{item.label}}</el-radio>        
                </div>
            </div>
            <div class="topic_left_type_list" v-else>
                 <div  class="selected publiRadio">
                     <el-radio v-model="radio" :label="radio" >{{$util.getTopicType(radio)}}</el-radio>        
                </div>
            </div>
        </div>
        <div class="topic_right">
            <div class="questionContainer">
                <!-- 试题题干 -->
                <div class="form-group">
                     <div class="group-title flex align-cen group-title-none">
                        <div class="question-title-typp">{{$util.getTopicType(radio)}}</div>
                        <span>-</span>
                        <span class="question-title-is">试题题干</span>
                    </div>
                    
                    <!-- 题干富文本 -->
                    <div class="group-body">
                           <quillsTemplate  @sendStatus="emitFun" :propData="titHtml"
                      :noneboo="false"
                      :limitNumb="500"
                        ref='quillTemplateRef'
                         :class="radio == 9 ? 'clozeClass' : ''"
                    ></quillsTemplate>
                             <div class="alert-warning extra" v-if="radio == 9" style="margin-top:85px;margin-bottom:0">
                            <div style="margin-bottom:0"> 
                                请在题干的适当位置放置光标，然后再点新增填空，增加一个空
                            </div>
                        </div>
                    </div>
                     <div class="flex align-cen" >
                        <el-button size="small" type="primary" class="progress-upload-media"  v-if="radio == 9" @click="addCloze">新增填空</el-button>
                            <el-upload
                    class="avatar-uploader"
                    :action="$config.baseUrl + '/admin/sys-file/upload?businessId=' + businessInfo.id"
                    :headers="headers"
                    :limit="1"
                    :show-file-list="true"
                    :on-success="audioSuccess"
                    :before-upload="beforeaudioUpload"
                    v-model="voiceUrl"
                    ref="upload"
                    >

                      <el-button size="small" type="primary" class="progress-upload-media" v-if="!voiceUrl">为题干增加音频文件</el-button>
                      <audio v-if="voiceUrl" :src="voiceUrl" controls>你的浏览器不支持 <code>audio</code> 标签.</audio></audio>
                      <div class="el-upload__tip icon-al-times-circle" slot="tip" @click="voiceUrl = ''" v-if="voiceUrl"></div>
                          </el-upload>
                     </div>
                      
                      <div class="group-title flex align-cen group-title1" v-if="radio!=4 && radio!=5">
                        <span>答案选项</span>
                    </div>
                  <div class="group-title flex align-cen group-title3" v-if="radio==4">
                        <span>要填的空和正确答案</span>
                    </div>
                        <div class="group-title flex align-cen group-title4" v-if="radio==5">
                        <span>参考答案</span>
                    </div>
                    <!-- 单选、多选是显示 -->
                     <div class="group-body answers" v-if="radio == 1 || radio == 2 || radio == 6">
                         <div class="moreCanvas"
                            v-for="(item,index) in questionList"
                            :key="index"
                            :id="'addCanvas'+index"
                            >
                            <div class="answer_heading flex align-cen">
                           <h5>{{'选项' + Eng[index]}}</h5>
                            <el-tooltip class="item" effect="dark" content="删除该项" placement="top">
                           <span class="icon-al-delete" v-if="questionList.length > 2"  @click="deletCanvas(item)"></span>
                            </el-tooltip>
                            </div>
                            <div class="answer-group">
                                 <quillsTemplatefor  @sendStatus="emitFun1" 
                                    :propData="item.content"
                                    :currindex="index"
                                    :tempname="index"
                                    :placeName="'选项' + Eng[index]"
                                    :ref="'quillTemplate' + index"
                                    ></quillsTemplatefor>
                            </div>
                                </div>
                            <div class="addnewanswers" @click="addnewanswers">
                                <i class="icon-al-plus-circle-fill"></i>
                                添加新选项
                            </div>
                            <div class="answer_heading">
                                <h5>
                                    正确答案：<span v-if="radio == 6" style="color:#999">（不定项选择题正确答案可以是一个或多个，请根据您的需求勾选正确答案选项。）</span>
                                </h5>
                            </div>
                            <div class="singleSelect" style="margin-top:15px" v-if="radio == 1">
                                 <el-radio-group v-model="rightSt" size="small">
                                    <el-radio :label="index" border
                                    v-for="(item,index) in questionList"
                                    :key="index"
                                    >
                                    （{{Eng[index]}}）
                                    </el-radio>
                                    </el-radio-group>
                            </div>
                             <div class="singleSelect" style="margin-top:15px" v-if="radio == 2 || radio == 6">
                                 <el-checkbox-group v-model="checkboxGroup" size="small">
                                        <el-checkbox :label="index" border
                                         v-for="(item,index) in questionList"
                                            :key="index"
                                        >
                                        （{{Eng[index]}}）
                                        </el-checkbox>
                                </el-checkbox-group>
                             </div>
                     </div>
                     <!-- 判断题时显示 -->
                     <div class="group-body" v-if="radio == 3">
                        <div class="true-group"
                         v-for="(item,index) in trueList"
                            :key="index"
                        >
                        <div class="answer_heading">
                            <h5>{{determine[index]}}</h5>
                        </div>
                         <el-input :placeholder="`请输入${determine[index]}文本内容`" v-model="item.content" clearable> </el-input>
                        </div>
                         <div class="answer_heading">
                                <h5>
                                    正确答案：
                                </h5>
                            </div>
                               <div class="singleSelect" style="margin-top:15px">
                                 <el-radio-group v-model="rightSt" size="small">
                                    <el-radio :label="index" border
                                    v-for="(item,index) in trueList"
                                    :key="index"
                                    >
                                    （{{determine[index]}}）
                                    </el-radio>
                                    </el-radio-group>
                            </div>
                     </div>
                     <!-- 填空题时显示 -->
                     <div class="group-body" v-if="radio == 4">
                        <div class="alert-warning extra">
                            <div>
                                下面列出了填空的个数，您需要在填空上写上正确答案。如果您的题含有不止一个空，您可以点击下面的按钮增加更多的空。
                            </div>
                            <div>
                               如果您的一个空可以<strong>有多个正确答案</strong> , 正确答案请用竖线 | 分开，例如：大象|象 
                            </div>
                            <div style="margin-bottom:0">
                                空旁边的分数表示该空答对时的得分， 如果留空， 则填空题任何一空错了， 整题的分数都为0，如果不留空，则哪一空回答对， 则得那空的分
                            </div>
                        </div>
                        <div class="extraList"
                        v-for="(item,index) in emptyList"
                        :key="index"
                        >
                        <div class="answer_heading" style="margin-bottom:12px">
                            <h5>({{Eng[index]}})</h5>
                        </div>
                        <div class="extraList-ipt flex align-cen">
                            <el-input placeholder="在这里写上该空的答案，如果有多个正确答案，请以竖线（｜）分开" v-model="item.content" clearable> </el-input>
                            <div class="point flex align-cen" style="width:200px;margin-left:20px">
                               <el-input placeholder="得分"  type="number" v-model="item.point" clearable :value="item.point" min="0" @input="updateValue(index)"> </el-input> <span style="margin-left:10px">分</span>
                            </div>
                             <span class="icon-al-delete" v-if="emptyList.length > 1" style="margin-left:20px;color:red;cursor: pointer;"  @click="deletEmpty(item)"></span>
                        </div>
                        </div>
                            <div class="addnewanswers" style="margin-top:32px" @click="addEmpty">
                                <i class="icon-al-plus-circle-fill"></i>
                                新增填空
                            </div>
                            <div class="allpoint" style="margin-bottom:20px">
                               <el-input placeholder="总分" v-model="score" clearable disabled :value="pointJs()"> </el-input>
                            </div>
                        <div class="extracheck">
                            <el-checkbox-group v-model="checkList">
                                <el-checkbox label="填空的答案无顺序要求"></el-checkbox>
                                <el-checkbox label="按空得分，只要一空答对就得分"></el-checkbox>
                                <el-checkbox label="忽略大小写"></el-checkbox>
                            </el-checkbox-group>
                        </div>
                     </div>
                                   <!-- 问答题显示 -->
                     <div class="group-body" v-if="radio == 5">
                      <quillsTemplate  @sendStatus="emitFun3" :propData="refAnswer"
                      :noneboo="false"
                        ref='quillTemplate2'
                    ></quillsTemplate>
                      <div class="alert-warning extra" style="padding-bottom:2px;margin-top:88px">
                            <div>
                                考完后修改试题答案，得分不会随之改变
                            </div>
                        </div>
                            <div class="extracheck">
                            <el-checkbox-group v-model="checkList1">
                                <el-checkbox label="按照关键字自动判分"></el-checkbox>
                            </el-checkbox-group>
                        </div>
                          <div class="alert-warning extra" >
                            <div>
                               1. 提前设定关键词，系统通过识别关键词来判断是否回答正确，考后系统自动出分。
                            </div>
                             <div style="margin-bottom:0">
                              2. 如果没有勾选按关键词自动判分，考生答卷需等待管理员后台手工判分。
                            </div>
                        </div>
                        <div class="keyword-body flex">
                          <div class="keywords-list" 
                             v-for="(item,index) in emptyList1"
                           :key="index"
                          >
                            <div class="keyword">
                              <div class="info">
                                <span>{{item.content}}</span>
                                <span>{{item.point}}</span>
                              </div>
                              <div class="action">
                                <span class="edit el-icon-edit-outline" title="编辑" @click="editKeyword(item,index)"></span>
                                <span class="delete el-icon-delete" title="删除" @click="deletKeyword(item)"></span>
                              </div>
                            </div>
                          </div>
                        </div>
                         <div class="addnewanswers" style="margin-top:12px;margin-bottom:0px" @click="editKeyword">
                                <i class="icon-al-plus-circle-fill"></i>
                                添加关键字
                            </div>
                              <div class="allpoint" style="margin-bottom:20px;margin-top:20px">
                               <el-input placeholder="总分" v-model="score" clearable :value="pointJs(1)" disabled  v-if="checkList1 && checkList1.length"> </el-input>
                                <el-input placeholder="总分" v-model="score" clearable   v-else> </el-input>
                            </div>
                     </div>
                           <!-- 不定项选择题时显示 -->
                     <div class="group-body" v-if="radio == 6">
                         <div class="answer_heading" style="padding:10px 0">
                                <h5>
                                    得分设置：
                                </h5>
                            </div>
                               <div class="extracheck">
                            <el-checkbox-group v-model="checkList2">
                                <el-checkbox label="允许自定义分数"></el-checkbox>
                            </el-checkbox-group>
                        </div>
                         <!-- v-if="checkList2 && checkList2.length" -->
                        <div class="option-scores flex align-cen"  v-if="checkList2 && checkList2.length" >
                          <div class="option-score" 
                          v-for="(item,index) in questionList"
                          :key="index"
                          >
                            <div class="label">
                              <div class="laber-tit">选项({{Eng[index]}})分数：</div>
                              <div class="laber-ipt">
                                <el-input :placeholder="`请输入选项${Eng[index]}的分数`" v-model="item.point"> </el-input>
                              </div>
                            </div>
                          </div>
                        </div>
                         <div class="answer_heading" style="padding:10px 0">
                                <h5>
                                   {{checkList2 && checkList2.length ? '可获得分数' : '题目分数'}}：
                                </h5>
                            </div>
                               <div class="group-body">
                        <div class="input-group" v-if="checkList2 && checkList2.length">
                             <el-input placeholder="总分" v-model="score" clearable disabled :value="pointJs(2)"> </el-input>
                        </div>
                        <div class="input-group" v-else>
                             <el-input placeholder="请输入题目分数" v-model="score" clearable @blur="validateInput"> </el-input>
                        </div>
                    </div>
                     </div>
                             <!-- 排序题时显示 -->
                     <div class="group-body Sortingquestion" v-if="radio == 7">
                       <div class="sortingquestion-option-container">
                        <div class="el__row" v-for="(item,index) in emptyList3" :key="`sortAnswers1${index}`">
                          <div class="sortingquestion-option flex align-cen">
                            <div class="sortingquestion-option-move">
                              <span class="icon-al-menu"></span>
                            </div>
                            <div class="sortingquestion-option-text">
                               <el-input placeholder="请输入试题内容" v-model="item.content" clearable > </el-input>
                            </div>
                            <div class="edit-btn-group" v-if="emptyList3.length > 2" @click="deletSortingquestion(item.content,index)">
                              <span class="el-icon-circle-close"></span>
                            </div>
                          </div>
                        </div>
                      </div>
                     <div class="addnewanswers" @click="addSortingquestion">
                                <i class="icon-al-plus-circle-fill"></i>
                                添加新选项
                            </div>
                      <div class="option-sorting-tips" style="font-size:14px;color:#d52b2b;margin-bottom:20px">*答案设置: 请把下列的语序拖动至正确的排序(排序前请先确定答案选项为最终项，如果在排序过程中再进行答案选项编辑、增加或删除，数据会发生错乱)</div>
                      <div class="sortingquestion-option-container" id="sortAnswers" v-if="sortshow">
                        <div class="el__row" v-for="(item,index) in emptyList3Copy" :key="`sortAnswers${index}`">
                          <div class="sortingquestion-option flex align-cen">
                            <div class="sortingquestion-option-move">
                              <span class="icon-al-menu handle_move"></span>
                            </div>
                            <div class="sortingquestion-option-text">
                               <el-input placeholder="请输入试题内容"v-model="emptyList3[index].content" clearable disabled> </el-input>
                            </div>
                            <div class="edit-btn-group"></div>
                          </div>
                        </div>
                      </div>
                     </div>
                                     <!-- 完形填空时显示 -->
                     <div class="group-body" v-if="radio == 9">
                  <el-table
                      ref="multipleTable"
                      :data="emptyList2"
                      tooltip-effect="dark"
                      style="width: 100%"
                      border
                      id='mytable'
                      :header-cell-style="{background:'#f7f8fa',color:'#333'}"
                    >
                      <el-table-column  label="题号" align="center">
                            <template slot-scope="scope">
                            <p>{{scope.$index + 1}}</p>
                          </template>
                      </el-table-column>
                      <el-table-column  label="选项" align="center" width="300">
                         <template slot-scope="scope">
                          <div class="flex align-cen options" v-for="(item,Cindex) in scope.row.clozeList" :key="Cindex">
                            <div class="option">
                              {{Eng[Cindex]}}. 
                            </div>
                            <div class="options-ipt">
                               <el-input placeholder="点击编辑" v-model="item.content"> </el-input>
                            </div>
                             <div class="options-icon flex align-cen">
                              <span class="el-icon-circle-plus" style="margin-left:15px;color:#36aafd" @click="addClozeChilden(scope.$index)"></span>
                               <span class="el-icon-delete-solid" @click="deletClozeChilden(scope.$index,item)"></span>
                             </div>
                          </div>
                         </template>
                      </el-table-column>
                       <el-table-column  label="正确答案" align="center">
                         <template slot-scope="scope">
                           <div class="radio-option">
                              <el-radio-group v-model="scope.row.isRight" size="small">
                                <!-- ${scope.$index}-${Cindex} -->
                                    <el-radio :label="Cindex" border
                                    v-for="(item,Cindex) in scope.row.clozeList"
                                    :key="Cindex"
                                    >
                                    {{Eng[Cindex]}}
                                    </el-radio>
                                    </el-radio-group>
                           </div>
                         </template>
                       </el-table-column>
                          <el-table-column  label="试题解析" align="center">
                             <template slot-scope="scope">
                                 <div class="options-ipt">
                               <el-input placeholder="点击编辑" v-model="scope.row.content" clearable=""> </el-input>
                            </div>
                             </template>
                          </el-table-column>
                             <el-table-column  label="分数" align="center">
                             <template slot-scope="scope">
                                 <div >
                                   <el-input placeholder="点击编辑" v-model="scope.row.point"> </el-input>
                                  </div>
                             </template>
                          </el-table-column>
                           <el-table-column  label="操作" align="center">
                            <template slot-scope="scope">
                            <div class="cltion" @click="deletCloze(scope.row,scope.$index + 1)" style="cursor: pointer;">
                              <span class="icon-al-delete"></span>
                            </div>
                            </template>
                           </el-table-column>
                  </el-table>
                   <div class="answer_heading" style="padding:10px 0">
                                <h5>
                                  可获得分数：
                                </h5>
                            </div>
                   <div class="allpoint" style="margin-bottom:20px;" v-if="emptyList2 && emptyList2.length">
                               <el-input placeholder="总分" v-model="score" clearable disabled :value="pointJs(3)"> </el-input>
                            </div>
                     </div>
                       <div class="group-title flex align-cen group-title1">
                        <span>题目解析</span>
                    </div>
                      <!-- 题干富文本 -->
                    <div class="group-body">
                           <quillsTemplate  @sendStatus="emitFun2" :propData="analysisHtml"
                      :noneboo="false"
                        ref='quillTemplate1'
                    ></quillsTemplate>
                    </div>
                     <div class="group-title flex align-cen group-title1 group-title2">
                        <span>题目分类</span>
                    </div>
                    <div class="group-body">
                        <div class="input-group" v-if="!editType">
                                    <el-select
                                    v-model="classifyId"
                                    clearable
                                    placeholder="请选择题目分类"
                                >
                                    <el-option
                                    v-for="item in options"
                                    :key="item.id"
                                    :label="item.name"
                                    :value="item.id"
                                    v-if="item.id!=2"
                                    >
                                    </el-option>
                                </el-select>
                        </div>
                          <div class="input-group" v-if="editType && isPlat !=1">
                                    <el-select
                                    v-model="classifyId"
                                    clearable
                                    placeholder="请选择题目分类"
                                >
                                    <el-option
                                    v-for="item in options"
                                    :key="item.id"
                                    :label="item.name"
                                    :value="item.id"
                                    v-if="item.id!=2"
                                    >
                                    </el-option>
                                </el-select>
                        </div>
                          <div class="input-group" v-if="editType && isPlat ==1">
                                    <el-select
                                    v-model="classifyId"
                                    clearable
                                    placeholder="请选择题目分类"
                                >
                                    <el-option
                                    v-for="item in options"
                                    :key="item.id"
                                    :label="item.name"
                                    :value="item.id"
                                    >
                                    </el-option>
                                </el-select>
                        </div>
                    </div>
                     <div class="group-title flex align-cen group-title1" v-if="radio!=4 && radio!=5 && radio!=6 && radio !=9">
                        <span>题目分数</span>
                    </div>
                    <div class="group-body" v-if="radio!=4 && radio!=5 && radio!=6 && radio !=9">
                        <div class="input-group">
                             <el-input placeholder="请输入题目分数" v-model="score" clearable @blur="validateInput"> </el-input>
                        </div>
                    </div>
                    <div class="group-title flex align-cen group-title1">
                        <span>试题标签</span>
                    </div>
                    <div class="group-body">
                            <div class="input-group">
                                    <el-select
                                    v-model="tag"
                                    clearable
                                    placeholder="请选择试题标签"
                                >
                                    <el-option
                                    v-for="item in tagList"
                                    :key="item"
                                    :label="item"
                                    :value="item"
                                    >
                                    </el-option>
                                </el-select>
                        </div>
                    </div>
                </div>
            </div>
        </div>
        </div>
        <!-- 试卷添加题库保存按钮 -->
          <div class="progress-upload-media paperBc" v-if="PropType" @click="onSubmit">保存</div>
             </div>
            </div>
                        <!-- 添加关键字遮罩 -->
      <el-dialog
  :title="titTopic"
  :visible.sync="centerDialogVisible"
  width="35%"
  :append-to-body="true"
  center>
   <div class="forminfo"
   >
    <div class="jBox-content">
      <div class="jBox-content-keyword">
        <div class="label">
          输入关键字
        </div>
         <el-input placeholder="输入关键字" v-model="keyWordContent" clearable maxlength="50"> </el-input>
      </div>
       <div class="jBox-content-keyword">
        <div class="label">
          可获得分数
        </div>
         <el-input placeholder="可获得分数" v-model="keyWordPoint" clearable maxlength="3"> </el-input>
      </div>
    </div>
    <div class="uaqbtns">
      <div class="keyWordCannel btn" @click="cannelKeyWord">
        取消
      </div>
      <div class="keywordAction btn" @click="addKeyWord">
        确定
      </div>
    </div>
   </div>
      </el-dialog>
    </div>
</template>
<script>
import quillsTemplate from "@/components/quill/index.vue"; //单富文本组件
import quillsTemplatefor from "@/components/quills/index.vue"; //多富文本组件
import Sortable from "sortablejs";
import {
  getQuestionClass,
  editEnQuestion,
  getEnQuestion,
  editPaperQuestion,
  getPaperEnQuestion
} from "@/api/enterprise/index"; // 题目分类、新增/修改题目、获取详情
export default {
  name: "addTopic",
  components: {
    quillsTemplate,
    quillsTemplatefor,
  },
  props: {
      PropType:[String, Number],
    topicID: [String, Number],
    propIndex:[String, Number],
    editType:[String, Number],
    editId:[String, Number],
    paperId:[String, Number],
    propData: {
      type: Object,
      default: () => {
        return {}
      }, // 默认值
    },
  },
  data() {
    return {
       sortshow:true,
      sortable:null,
      oldIndex: null,
      newIndex: null,
      Cloze:0,
      keyWordContent:'',
      keyWordPoint:1,
      keyWordIndex:-1,
      titTopic:'新增关键字',
      centerDialogVisible:false,
      isPlat:'',
      businessInfo:{},
      checkList: ["忽略大小写"],
         checkList1:[],
      checkList2:[],
      checkboxGroup: [],
      tag: "",
      score: "",
      classifyId: "",
      options: [],
      rightSt: "",
      Eng: ["A", "B", "C", "D", "E", "F", "G", "H", "I", "J"],
      determine: ["真项", "假项"],
      trueList: [
        {
          content: "正确",
          isRight: 0,
        },
        {
          content: "错误",
          isRight: 0,
        },
      ],
      emptyList: [
        {
          content: "",
          isRight: 1,
          point: 1,
        },
      ],
     emptyList1:[
      ],
      emptyList2:[
      ],
      emptyList3:[
        {
          content: "",
          isRight: 1,
          point: 1,
          sort:1
        },
         {
          content: "",
          isRight: 2,
          point: 1,
          sort:2
        },
         {
          content: "",
          isRight: 3,
          point: 1,
          sort:3
        },
         {
          content: "",
          isRight: 4,
          point: 1,
          sort:4
        }
      ],
       emptyList3Copy:[],
      voiceUrl: "",
      fileList: [],
      headers: {},
      analysisHtml: "",
       refAnswer:'',
      titHtml: "",
      radio: 1,
      loading: false,
      radioList: [
        {
          id: 1,
          label: "单选题",
        },
        {
          id: 2,
          label: "多选题",
        },
        {
          id: 3,
          label: "判断题",
        },
        {
          id: 4,
          label: "填空题",
        },
        {
          id: 5,
          label: "问答题",
        },
        {
          id: 6,
          label: "不定项选择题",
        },
        {
          id: 7,
          label: "排序题",
        },
        {
          id: 9,
          label: "完形填空题",
        },
      ],
      tagList: ["常识", "较难", "难", "很难"],
      questionList: [
        {
          content: "",
          isRight: 0,
        },
        {
          content: "",
          isRight: 0,
        },
        {
          content: "",
          isRight: 0,
        },
        {
          content: "",
          isRight: 0,
        },
      ],
    };
  },
  computed: {},
  created() {
     this.emptyList3Copy = [...this.emptyList3]
           let token = this.$locaStorage.setAge().get('token1')
        if(token){
            this.headers = {
                'Authorization': token
            }
        }
     this.businessInfo = this.$locaStorage.setAge().get('businessInfo')
  },
  mounted() {
    if (this.propData && !this.$route.query.type && !this.PropType) {
      this.isPlat = this.propData.isPlat
      this.radio = Number(this.propData.type);
      this.titHtml = this.propData.title;
      this.analysisHtml = this.propData.analysis;
        this.refAnswer = this.propData.refAnswer;
      this.classifyId = this.propData.classifyId;
      this.score = this.propData.score;
      this.tag = this.propData.tag;
      if (this.propData.type == 1 || this.propData.type == 2 || this.propData.type == 6) {
        this.questionList = this.propData.answerList;
        this.propData.answerList.forEach((t, index) => {
          if (t.isRight == 1) {
            this.propData.type == 1
              ? (this.rightSt = index)
              : this.checkboxGroup.push(index);
          }
        });
      }
      if (this.propData.type == 3) {
        this.trueList = this.propData.answerList;
        this.propData.answerList.forEach((t, index) => {
          if (t.isRight == 1) {
            this.rightSt = index;
          }
        });
      }
      if (this.propData.type == 4) {
        this.emptyList = this.propData.answerList;
        this.checkList = this.propData.rule.split("|");
      }
         if (this.propData.type == 5) {
        this.emptyList1 = this.propData.answerList;
        this.checkList1 = this.propData.rule ? this.propData.rule.split("|") : [];
      }
      if(this.radio == 6) this.checkList2 = this.propData.rule ? this.propData.rule.split("|") : [];
      if(this.radio == 7){
         this.emptyList3 = this.propData.answerList
             this.emptyList3Copy = [...this.emptyList3].sort((a, b) => a.sort - b.sort);
             this.$nextTick(() => {
                this.init()
              })
      }
       if(this.radio == 9){
          this.emptyList2 = this.propData.answerList;
              this.propData.answerList.forEach((t, index) => {
                this.emptyList2[index].isRight = Number(t.isRight);
        });
      }
    }
           this.getClass();
     if (this.$route.query.id || this.topicID) {
        this.getDetail();
      }
  },
  methods: {
      // 问答题关键字编辑
    editKeyword(data,index){
      if(data.content){
       this.keyWordIndex = index
        this.keyWordContent = data.content;
        this.keyWordPoint = data.point;
      }
      this.centerDialogVisible = true
    },
    validateInput(){
    const inputNumber = parseFloat(this.score);  
         if (isNaN(inputNumber) || inputNumber <= 0 || !/^0\.\d{1,2}$|^0\.[1-9]\d$|^[1-9](\.\d{1,2})?$|^[1-9]\d(\.\d{1,2})?$|^100$|^100.0$|^100.00$/.test(this.score)) {  
        this.score = ''; // 清空输入框 
        this.$util.Notifi('分数必须大于0且只包含100以内数字', "error", "fa-exclamation-circle");         
      }
    },
    //
    emitData() {
        let arrdata = {}
        let answerList = [];
                // 重新组装数据
        if (this.radio == 1) {
          this.questionList.forEach((t) => {
            t.isRight = 0;
          });
          (this.questionList[this.rightSt].isRight = 1),
            (answerList = this.questionList);
        }
        if (this.radio == 3) {
          this.trueList.forEach((t) => {
            t.isRight = 0;
          });
          (this.trueList[this.rightSt].isRight = 1),
            (answerList = this.trueList);
        }
        if (this.radio == 4) answerList = this.emptyList;
        if (this.radio == 5) answerList = this.emptyList1;
        if (this.radio == 2 || this.radio == 6) {
          this.questionList.forEach((t, index) => {
            t.isRight = 0;
            this.checkboxGroup.forEach((k) => {
              if (index == k) {
                this.questionList[index].isRight = 1;
              }
            });
          });
          answerList = this.questionList;
        }
           if(this.radio == 9){
          this.emptyList2.forEach((t,index) => {
           t.clozeList[t.isRight].isRight = 1
          })
            answerList = this.emptyList2;
        }
               if(this.radio == 7){
              let b = this.emptyList3Copy
              let a = this.emptyList3
          // 使用map和findIndex来更新a数组的sort属性  
                  a = a.map(itemA => {  
                      const indexB = b.findIndex(itemB => itemB.isRight === itemA.isRight);  
                      if (indexB !== -1) {  
                          // 如果找到了对应的索引，则创建新对象并更新sort属性  
                          return { ...itemA, sort: indexB + 1 };  
                      } else {  
                          // 如果没有找到对应的索引，则保持原样（或进行其他处理）  
                          // 这里假设我们想要保持原sort值不变  
                          return itemA;  
                      }  
                  });  
                    
                 answerList = a;
        }
      arrdata= {
        createBy: null,
        createTime: null,
        updateBy: null,
        updateTime: null,
        id: null,
        businessId: this.businessInfo.id,
        title: this.titHtml,
        type: this.radio,
        analysis: this.analysisHtml,
        classifyId: this.classifyId,
        score: this.score,
        tag: this.tag,
         refAnswer: this.refAnswer,
        rule:this.radio == 4 ? this.checkList.join("|") : this.radio == 5 ? this.checkList1.join("|") : this.radio == 6 ? this.checkList2.join("|") : "",
        isPlat: "1",
        delFlag: null,
        paperNum: null,
        classifyName: "未分类",
        answerList: answerList,
        paperList: null,
        duplicateList: null,
        isTrue: true,
      };
      this.$emit('emitFun', arrdata,this.propIndex);
    },
    updateValue(index) {
      this.emptyList[index].point = Math.max(0, this.emptyList[index].point);
    },
    // 获取详情
    getDetail() {
      let urlobj = this.editType ? getPaperEnQuestion({ id: this.editId, businessId:this.businessInfo.id}): getEnQuestion({ id: this.$route.query.id || this.topicID, businessId:this.businessInfo.id}, "get",'enterprise')
      urlobj.then(
        (res) => {
          if (res.code == 0) {
            this.isPlat = res.data.isPlat
            this.voiceUrl = res.data.audio,
            this.radio = res.data.type;
            this.titHtml = res.data.title;
            this.analysisHtml = res.data.analysis;
             this.refAnswer = res.data.refAnswer;
            res.data.isPlat == 1 ? this.classifyId = '2' :  this.classifyId = res.data.classifyId
            this.score = res.data.score;
            this.tag = res.data.tag;
            if (res.data.type == 1 || res.data.type == 2 || res.data.type == 6) {
              this.questionList = res.data.answerList;
              res.data.answerList.forEach((t, index) => {
                if (t.isRight == 1) {
                  res.data.type == 1
                    ? (this.rightSt = index)
                    : this.checkboxGroup.push(index);
                }
              });
            }
            if (res.data.type == 3) {
              this.trueList = res.data.answerList;
              res.data.answerList.forEach((t, index) => {
                if (t.isRight == 1) {
                  this.rightSt = index;
                }
              });
            }
            if (res.data.type == 4) {
              this.emptyList = res.data.answerList;
              this.checkList = res.data.rule.split("|");
              console.log(this.checkList);
            }
                  if (res.data.type == 5) {
              this.emptyList1 = res.data.answerList;
              this.checkList1 = res.data.rule ? res.data.rule.split("|") : [];
            }
            if(this.radio == 6) this.checkList2 = res.data.rule ? this.propData.rule.split("|") : [];
            if(this.radio == 7){
              this.emptyList3 = res.data.answerList
             this.emptyList3Copy = [...this.emptyList3].sort((a, b) => a.sort - b.sort);
             this.$nextTick(() => {
                this.init()
              })
              
            }
            if(this.radio == 9){
               this.emptyList2 = res.data.answerList;
                    res.data.answerList.forEach((t, index) => {
                      this.emptyList2[index].isRight = Number(t.isRight);
              });
            }
          } else {
            this.$util.Notifi(res.msg, "error", "fa-exclamation-circle");
          }
        }
      );
    },
    // 题型切换
    swichType() {
      if (this.$route.query.id) {
        this.titHtml = "";
        this.voiceUrl = "";
        this.rightSt = "";
        this.checkboxGroup = [];
        this.analysisHtml = "";
        this.classifyId = "";
        this.score = "";
        this.tag = "";
        this.refAnswer = "";
         this.emptyList1 = []
        this.emptyList2 = []
          this.checkList1 = []
        this.checkList2 = []
        (this.checkList = ["忽略大小写"]),
          (this.emptyList = [
            {
              content: "",
              isRight: 1,
              point: 1,
            },
          ]),
          (this.trueList = [
            {
              content: "正确",
              isRight: 0,
            },
            {
              content: "错误",
              isRight: 0,
            },
          ]);
        this.questionList = [
          {
            content: "",
            isRight: 0,
          },
          {
            content: "",
            isRight: 0,
          },
          {
            content: "",
            isRight: 0,
          },
          {
            content: "",
            isRight: 0,
          },
        ];
         this.emptyList3 = [
        {
          content: "",
          isRight: 1,
          point: 1,
          sort:1
        },
         {
          content: "",
          isRight: 2,
          point: 1,
          sort:2
        },
         {
          content: "",
          isRight: 3,
          point: 1,
          sort:3
        },
         {
          content: "",
          isRight: 4,
          point: 1,
          sort:4
        }
      ]
      this.emptyList3Copy = [...this.emptyList3]
      }else{
              if(this.radio == 7){
                this.init()
              }
      }
    },
    // 提交操作
    onSubmit() {
      const isKey = ["titHtml", "analysisHtml", "classifyId", "score", "tag"];
      const tipText = [
        "请输入试题题干",
        "请输入题目解析",
        "请选择题目分类",
        "请输入题目分数",
        "请选择试题标签",
      ];
      let isflag = false;
      let answerList = [];
      // 循环验证必填项
      isflag = isKey.some((t, index) => {
        if (!this[t]) {
          this.$util.Notifi(tipText[index], "error", "fa-exclamation-circle");
          return true;
        } else {
          return false;
        }
      });
      // 当isflag为false继续执行
      if (!isflag) {
        // 验证是否选择
        if ((this.radio == 1 || this.radio == 3) && this.rightSt === "")
          return this.$util.Notifi(
            "请选择正确答案",
            "error",
            "fa-exclamation-circle"
          );
        if (this.radio == 2 && !this.checkboxGroup.length)
          return this.$util.Notifi(
            "请至少选择两个答案",
            "error",
            "fa-exclamation-circle"
          );
        if (this.radio == 4) {
          let empty = false;
          empty = this.emptyList.some((t, index) => {
            if (!t.content) {
              this.$util.Notifi(
                `请输入${this.Eng[index]}项的答案`,
                "error",
                "fa-exclamation-circle"
              );
              return true;
            } else {
              empty = false;
            }
          });
          if
           (empty) return;
        }
        if(this.radio == 5){
          if(!this.refAnswer) return this.$util.Notifi("请输入参考答案","error","fa-exclamation-circle")
        }
        // 重新组装数据
        if (this.radio == 1) {
          this.questionList.forEach((t) => {
            t.isRight = 0;
          });
          (this.questionList[this.rightSt].isRight = 1),
            (answerList = this.questionList);
        }
        if (this.radio == 3) {
          this.trueList.forEach((t) => {
            t.isRight = 0;
          });
          (this.trueList[this.rightSt].isRight = 1),
            (answerList = this.trueList);
        }
        if (this.radio == 4) answerList = this.emptyList;
        if (this.radio == 5) answerList = this.emptyList1;
        if (this.radio == 2 || this.radio == 6) {
          this.questionList.forEach((t, index) => {
            t.isRight = 0;
            this.checkboxGroup.forEach((k) => {
              if (index == k) {
                this.questionList[index].isRight = 1;
              }
            });
          });
          answerList = this.questionList;
        }
           if(this.radio == 9){
          this.emptyList2.forEach((t,index) => {
           t.clozeList[t.isRight].isRight = 1
          })
            answerList = this.emptyList2;
        }
             if(this.radio == 7){
              let b = this.emptyList3Copy
              let a = this.emptyList3
          // 使用map和findIndex来更新a数组的sort属性  
                  a = a.map(itemA => {  
                      const indexB = b.findIndex(itemB => itemB.isRight === itemA.isRight);  
                      if (indexB !== -1) {  
                          // 如果找到了对应的索引，则创建新对象并更新sort属性  
                          return { ...itemA, sort: indexB + 1 };  
                      } else {  
                          // 如果没有找到对应的索引，则保持原样（或进行其他处理）  
                          // 这里假设我们想要保持原sort值不变  
                          return itemA;  
                      }  
                  });  
                    
                 answerList = a;
        }
        let params = {
         businessId:this.businessInfo.id,
          audio:this.voiceUrl,
          type: this.radio,
          title: this.titHtml,
          analysis: this.analysisHtml,
          classifyId: this.classifyId,
          score: this.score,
          tag: this.tag,
           refAnswer:this.refAnswer,
           rule: this.radio == 4 ? this.checkList.join("|") : this.radio == 5 ? this.checkList1.join("|") : this.radio == 6 ? this.checkList2.join("|") : "",
          answerList: answerList,
        };
        let method = "post";
        if (!this.$route.query.id && !this.topicID)
          (params = { ...params }), (method = "post");
        if (this.$route.query.id || (this.topicID && !this.editId))
          (params = { ...params, id: this.$route.query.id || this.topicID }),
            (method = "put");
          if(this.editType){
           params = { ...params, id:this.editId,questionId:this.topicID,paperId:this.paperId}
           this.commentBness1(params);
          }else{
            this.commentBness(params, method);
          }
      }
    },
    commentBness(params, method) {
      this.loading = true;
      editEnQuestion(params, method,'enterprise')
        .then((res) => {
          this.loading = false;
          if (res.code == 0) {
             if(this.PropType){
             this.$emit('sendStatus',res.data)
            }
            if (!this.$route.query.id && !this.topicID)
              this.$util.Notifi("新增成功", "success", "fa-check");
            if (this.$route.query.id || this.topicID)
              this.$util.Notifi("修改成功", "success", "fa-check");
            if (!this.topicID && !this.PropType) {
              setTimeout(() => {
                this.$router.push("/teacheManage/questionList");
              }, 100);
            }
          } else {
            this.$util.Notifi(res.msg, "error", "fa-exclamation-circle");
          }
        })
        .catch((err) => {
          this.loading = false;
        });
    },
      // 修改试题中的题目
        commentBness1(params) {
      this.loading = true;
      editPaperQuestion(params)
        .then((res) => {
          this.loading = false;
          if (res.code == 0) {
            this.$emit('custom-event',true)
            this.$util.Notifi("修改成功", "success", "fa-check");
          } else {
            this.$emit('custom-event',false)
            this.$util.Notifi(res.msg, "error", "fa-exclamation-circle");
          }
        })
        .catch((err) => {
          this.loading = false;
        });
    },
    pointJs(type) {
      // 1、问答题，2、不定项选择题，3、完形填空
      let total = 0;
      let listVar = type==1 ? this.emptyList1 : type==2 ? this.questionList : type == 3 ? this.emptyList2 : this.questionList
      for (let key in  listVar) {
        total += Number(listVar[key].point);
      }
      this.score = total.toFixed(2);
    },
    // 获取题目分类
    getClass() {
      getQuestionClass({name:'', businessId:this.businessInfo.id,size:1000,current:1,},'enterprise')
        .then((res) => {
          this.options = res.data.records;
        })
        .catch((err) => {});
    },
    // 删除单选多选答案选项
    deletCanvas(data) {
      let arr = [];
      arr.push(data);
      let delet = this.questionList.filter(
        (item) => !arr.some((ele) => ele === item)
      );
      this.questionList = delet;
    },
    deletEmpty(data) {
      let arr = [];
      arr.push(data);
      let delet = this.emptyList.filter(
        (item) => !arr.some((ele) => ele === item)
      );
      this.emptyList = delet;
    },
      // 删除关键字
    deletKeyword(data){
       let arr = [];
      arr.push(data);
      let delet = this.emptyList1.filter(
        (item) => !arr.some((ele) => ele === item)
      );
      this.emptyList1 = delet;
    },
    updateStringAndArray(array,indexToRemove) {  
  // 移除数组中的元素  
  if (indexToRemove >= 0 && indexToRemove < array.length) {  
    array.splice(indexToRemove, 1);  
  }  
  return {  
    updatedArray: array  
  };  
},
     // 删除完形填空
    deletCloze(data,index){
      let bStr = index.toString();
      let regex = new RegExp(`{{\\b${bStr}\\b}}`, 'g'); 
      let updatedA = this.titHtml.replace(regex, '');  
        console.log(updatedA)
      let regex1 = /{{(\d+)}}/g; 
      this.titHtml = updatedA.replace(regex1, (match, capture) => {  
    // 捕获组 capture 包含了括号内的内容（即数字字符串）  
    let num = parseInt(capture, 10); // 将字符串转换为数字  
    // 检查数字是否大于0，避免减1后成为负数  
    if (num > index) {  
        return `{{${num - 1}}}`; // 返回新的 {{}} 序列，数字减1  
    } else {  
        // 如果数字已经是0或负数，可以选择保持原样、返回空字符串或其他处理方式  
        return match; // 这里为了简单起见，我们保持原样不变  
    }  
});
      const {updatedArray } = this.updateStringAndArray(this.emptyList2, index - 1);
      // const updatedStr = this.updatePlaceholders(this.titHtml, index);
      // console.log(updatedStr)
      // console.log(updatedString)
      //  console.log(updatedArray)
    // let patternString = `{{${this.emptyList2.length}}}`;
    //  this.titHtml = updatedString
    //      let arr = [];
    //   arr.push(data);
    //   let delet = this.emptyList2.filter(
    //     (item) => !arr.some((ele) => ele === item)
    //   );
    //   this.emptyList2 = delet;
    },
    // 删除排序选项
    deletSortingquestion(data,index){
        this.sortshow = false
       this.emptyList3.splice(index, 1); 
             this.emptyList3Copy = [...this.emptyList3 ]
          this.$nextTick(() => {  
          this.sortable.destroy()
 this.sortshow = true
  this.$nextTick(() => {  
     this.init()
  })
});
    },
    // 单选多选添加新选项
    addnewanswers() {
      if (this.questionList.length >= 10)
        return this.$util.Notifi(
          "最多添加10项",
          "error",
          "fa-exclamation-circle"
        );
      this.questionList.push({
        content: "",
        isRight: 0,
      });
    },
    // 新增填空
    addEmpty() {
      if (this.emptyList.length >= 10)
        return this.$util.Notifi(
          "最多添加10项",
          "error",
          "fa-exclamation-circle"
        );
      this.emptyList.push({
        content: "",
        isRight: 1,
        point: 1,
      });
    },
        // 新增关键字
    addKeyWord(){
      if(!this.keyWordContent) return this.$util.Notifi("请输入关键字","error","fa-exclamation-circle");
      if (isNaN(inputNumber) || inputNumber <= 0 || !/^0\.\d{1,2}$|^0\.[1-9]\d$|^[1-9](\.\d{1,2})?$|^[1-9]\d(\.\d{1,2})?$|^100$|^100.0$|^100.00$/.test(this.keyWordPoint)) {  
        this.keyWordPoint = ''; // 清空输入框 
        this.$util.Notifi('分数必须0-100之间', "error", "fa-exclamation-circle");    
        return
    }
      if(this.keyWordIndex >=0){
        this.emptyList1[this.keyWordIndex].content = this.keyWordContent;
         this.emptyList1[this.keyWordIndex].point = this.keyWordPoint;
      }else{
      this.emptyList1.push({
        content: this.keyWordContent,
        isRight: 1,
        point: this.keyWordPoint,
      });
      }
      this.keyWordIndex = -1
      this.keyWordContent = ''
      this.keyWordPoint = 1
       this.centerDialogVisible = false
    },
    // 完形填空添加新选项
    addCloze(){
       this.emptyList2.push({
          isRight:0,
          content:'',
          point:1,
          clozeList:[
            {
              isRight:0,
              content:''
            },
            {
              isRight:0,
              content:''
            },
            {
              isRight:0,
              content:''
            },
            {
              isRight:0,
              content:''
            }
          ]
        });
       this.$refs.quillTemplateRef.onEditorChange1(this.emptyList2.length)
    },
    // 添加完形填空选项
    addClozeChilden(cindex){
      this.emptyList2[cindex].clozeList.push({
         isRight:0,
              content:''
      })
    },
    // 添加排序选项
    addSortingquestion(){
      this.emptyList3.push({
        content: "",
        isRight: this.emptyList3.length + 1,
        point: 1,
        sort:this.emptyList3.length + 1
      });
        this.emptyList3Copy = [...this.emptyList3]
    },
    // 删除完形填空选项
deletClozeChilden(cindex,data){
    let arr = [];
      arr.push(data);
      let delet = this.emptyList2[cindex].clozeList.filter(
        (item) => !arr.some((ele) => ele === item)
      );
    this.emptyList2[cindex].clozeList = delet;
},
    // 取消关键字
    cannelKeyWord(){
      this.keyWordIndex = -1
      this.keyWordContent = ''
      this.keyWordPoint = 1
      this.centerDialogVisible = false
    },
               	init(){
		// 1. 获取拖拽元素的父元素
		// 因为使用的element的table 所以可直接获取tbody
		let el =  document.getElementById("sortAnswers");
		let that = this;	
		// 2. 创建并配置相关参数
		 this.sortable = new Sortable(el, {			
			// 只有按住手柄才能进行拖拽
            handle:'.handle_move',
			// 行拖拽，所以该值设置为行class            
			// 因为拖拽过程中不尽兴位置调整，所以就要记录拖拽行初始位置以及目标位置
      draggable:'.el__row', // 允许拖拽的项目类名	
		// 拖拽结束，调整位置
			onEnd(event) {
              let oldIndex = event.oldIndex;
                let newIndex = event.newIndex;  
                 let temp = that.emptyList3Copy[oldIndex];
                 if(oldIndex < newIndex){
                      for(var i = oldIndex ; i < newIndex ; i++){
                        that.emptyList3Copy[i] = that.emptyList3Copy[i+1];
                    }
              }
              if(oldIndex > newIndex){
                for(var i = oldIndex ; i > newIndex ; i--){
                        that.emptyList3Copy[i] = that.emptyList3Copy[i-1];
                    }
              }
              console.log(temp)
              that.emptyList3Copy[newIndex] = temp;        
	        },
		})
	},
    // 选项子组件触发
    emitFun1(val, index) {
      this.questionList[index].content = val;
    },
    // 题干子组件触发的方法
    emitFun(val, index) {
      this.titHtml = val;
    },
    // 解析子组件触发
    emitFun2(val, index) {
      this.analysisHtml = val;
    },
     // 解析子组件触发
    emitFun3(val, index) {
      this.refAnswer = val;
    },
    audioSuccess(res, file, fileList) {
      if (res.code == 0) {
        this.voiceUrl = res.data.url;
        this.$refs.upload.clearFiles();
      } else {
        this.$util.Notifi(res.msg, "error", "fa-exclamation-circle");
        this.$refs.upload.clearFiles();
      }
    },
    beforeaudioUpload(file) {
      const isLt10M = file.size / 1024 / 1024 < 1024;
      if (["audio/mp3", "audio/mpeg"].indexOf(file.type) == -1) {
        this.$util.Notifi(
          "请上传正确的音频格式",
          "error",
          "fa-exclamation-circle"
        );
        return false;
      }
      if (!isLt10M) {
        this.$util.Notifi(
          "上传音频大小不能超过1GB哦!",
          "error",
          "fa-exclamation-circle"
        );
        return false;
      }
    },
  },
};
</script>
<style lang="scss" scoped>
#addTopic {
  height: inherit;
  overflow: hidden;
}
.forminfo{
  .jBox-content{
   .jBox-content-keyword{
    margin-bottom: 28px;
    .label{
      margin-bottom: 12px;
    }
   } 
  }
  .uaqbtns{
    margin-top: 20px;
    display: flex;
    justify-content: end;
    .btn{
      cursor: pointer;
      color: #999;
    border: 1px solid #e4e4e4;
    background-color: white;
    padding: 7px 20px;
    border-radius: 4px !important;
    margin-right: 10px;
    }
    .keywordAction{
      margin-right: 0;
      background-color: #36aafd;
    color: white;
    border: 1px solid #36aafd;
    padding: 7px 20px;
    border-radius: 4px !important;
    }
  }
}
.paperBc{
    cursor: pointer;
    text-align: center;
    background: #155bd4;
    width: 120px;
    color: #fff;
    margin: 0 auto;
     margin-top: 20px;
     height: 34px;
     line-height: 34px;
     border-radius: 5px;
  }
.edit-from {
  margin-bottom: 44px;
  .topic_container {
    align-items: flex-start;
    padding: 0;
    .topic_left {
      width: 160px;
        height: calc(100vh - 260px);
       overflow-y: scroll;
      .topic_left_tit {
        height: 69px;
        line-height: 69px;
        padding-left: 24px;
        font-size: 16px;
        font-weight: 700;
        color: #333333;
      }
      .topic_left_type_list {
        .publiRadio {
          margin: 0 0 12px 0 !important;
          padding: 10px 24px !important;
          border: none;
          font-size: 14px;
          color: #999999;
        }
        .selected {
          font-weight: 700;
          background-color: #f5fbff;
        }
      }
    }
 /*滚动条样式*/
    .topic_right::-webkit-scrollbar,.topic_left::-webkit-scrollbar {
      width: 6px !important;
      height: 6px !important;
      border-radius: 4px !important;
    }
    .topic_right::-webkit-scrollbar-thumb,.topic_left::-webkit-scrollbar-thumb{
      border-radius: 10px;
      box-shadow: inset 0 0 5px rgba(255, 255, 255, 0.2);
      background: rgba(144, 147, 153, 0.3) !important;
      border-radius: 4px !important;
    }
    .topic_right::-webkit-scrollbar-track, .topic_left::-webkit-scrollbar-track {
      background: transparent !important;
    }
    .topic_right::-webkit-scrollbar-corner,.topic_left::-webkit-scrollbar-corner {
      background: rgba(0, 0, 0, 0) !important;
    }
    .topic_right {
      height: calc(100vh - 260px);
      overflow-y: scroll;
      width: calc(100% - 160px);
      .questionContainer {
        padding: 44px 44px 0;
        .form-group {
          margin-bottom: 20px;
          .extra {
            height: unset;
            line-height: unset;
            margin-bottom: 20px;
            padding: 12px 24px 12px 48px;
            text-indent: 0;
            position: relative;
            font-size: 14px;
            color: #666666;
            background-color: #fff2e6;
            border-radius: 4px !important;
            div {
              margin-bottom: 10px;
            }
          }
          .alert-warning::before {
            content: "";
            position: absolute;
            top: 14px;
            left: 24px;
            transform: translateY(0);
            width: 16px;
            height: 16px;
            background: url("../../../assets/images/warn.png") no-repeat
              center center;
          }
            .group-title {
            position: relative;
            margin-bottom: 24px;
            font-size: 16px;
            font-weight: 700;
            color: #333;
            text-indent: 12px;
          }
          .group-title::before {
            content: "";
            position: absolute;
            top: 50%;
            left: 0;
            transform: translateY(-50%);
            width: 4px;
            height: 16px;
            background-color: #36aafd;
            border-radius: 2px !important;
          }
          .group-title::after {
            content: "*";
            position: absolute;
            top: 55%;
            left: 150px;
            transform: translateY(-50%);
            color: #d52b2b;
          }
          .group-title-none::after{
            content: none !important;
          }
                  .question-title-is{
            position: relative;
            display: inline-block;
          }
          .question-title-is::after{
             content: "*";
            position: absolute;
            top: 55%;
            right: -15px;
            transform: translateY(-50%);
            color: #d52b2b;
          }
          .group-title1::after {
            left: 70px !important;
          }
          .group-title3:after {
            left: 150px !important;
          }
          .group-title4:after {
            left: 70px !important;
          }
          .group-title2 {
            margin-top: 88px;
          }
          .group-body {
            padding-left: 12px;
            margin-bottom: 24px;
            .input-group {
              .el-select {
                width: 100% !important;
              }
            }
            .true-group {
              margin-top: 20px;
              h5 {
                margin-bottom: 12px;
              }
            }
            .extraList-ipt {
              margin-bottom: 12px;
            }
          }
          .answer_heading {
            h5 {
              font-size: 14px;
              color: #333;
              font-weight: 400;
            }
            span {
              cursor: pointer;
              color: red;
              margin-left: 10px;
              font-size: 12px;
            }
          }
          .addnewanswers {
            margin-bottom: 32px;
            margin-right: 12px;
            cursor: pointer;
            background-color: #36aafd;
            color: white;
            border: 1px solid #36aafd;
            padding: 7px 20px;
            border-radius: 4px !important;
            width: 120px;
            text-align: center;
          }
          .addnewanswers:hover {
            background: #0077ff;
          }
          .progress-upload-media {
            display: block;
            margin-left: 12px;
            margin-top: 20px;
            margin-bottom: 20px;
            width: 150px;
            text-align: center;
            color: #fff;
            height: 40px;
            border-radius: 4px;
            background-color: #36aafd;
          }
          audio {
            display: block;
            margin-bottom: 20px;
            margin-top: 20px;
            margin-left: 20px;
          }
          .el-upload__tip{
             margin-left: 20px;
          }
        }
      }
    }
  }
    .option-scores {
    flex-wrap: wrap;
   .option-score{
    width: 23.5%;
    margin-bottom: 10px;
    .laber-tit{
      padding-bottom: 5px;
    }
   } 
  }
    .keyword-body{
    flex-wrap: wrap;
    align-items: flex-start;
    margin-bottom: 20px;
    .keywords-list{
      .keyword{
        margin: 0 12px 0px 0;
    padding: 7px 24px;
    border: solid 1px #e6e6e6;
    font-size: 14px;
    color: #333333;
    border-radius: 100px;
    cursor: pointer;
    position: relative;
    .info{
       display: block;
      span:last-child {
        margin-left: 20px;
      }
    }
    .action{
      display: none;
      span{
        display: inline-block;
    font-size: 28px;
    transform: scale(0.5714);
    vertical-align: middle;
      }
      span:hover{
        color: #36aafd;
      }
    }
      }
      .keyword:hover .action{
        display: block;
        position: absolute;
    display: block;
    left: 0px;
    right: 0px;
    text-align: center;
    width: unset !important;
    top: 50% !important;
    transform: translateY(-50%);
      }
       .keyword:hover .info{
        visibility: hidden;
       }
    }
  }
    .sortingquestion-option-container{
    .el__row{
      margin-bottom: 20px;
      .sortingquestion-option{
        position: relative;
       .sortingquestion-option-move{
        text-align: center;
            width: 36px;
            height: 36px;
            background-color: #f3f3f3;
            border-radius: 4px 0px 0px 4px !important;
            border: solid 1px #ccc;
            cursor: grab;
            line-height: 34px;
            box-sizing: border-box;
            span{
              font-size: 18px;
              color: #999;
              vertical-align: middle;
              transform: translateY(50%);
            }
       } 
       .edit-btn-group{
        font-size: 18px;
        color: red;
        margin-left: 30px;
        margin-right: 30px;
        cursor: pointer;
       }
      }
    }
  }
}

::v-deep {
    .sortingquestion-option-text{
    flex: 1;
    width: 100%;
    .el-input{
      .el-input__inner{
        height: 36px;
       border-radius: 0 4px 4px 0 !important;
       line-height: 36px;
       font-size: 14px;
    font-weight: normal;
    color: #333;
    background-color: #fff;
    border: 1px solid #e5e5e5;
      }
    }
  }
    .radio-option{
    .el-radio.is-bordered{
      border: none;
      margin: 0;
      display: block;
    }
  }
      .laber-ipt{
      width: 70%;
      .el-input__inner{
        height: 35px !important;
        line-height: 35px !important;
      }
    }
    .options{
      justify-content: center;
      margin-bottom: 8px;
      .option{
        margin-right: 5px;
      }
      .options-ipt{
        .el-input__inner{
        height: 30px !important;
        line-height: 30px !important;
      }
      }
      .options-icon{
        visibility: hidden;
        span{
          font-size: 18px;
          margin: 0 5px;
          cursor: pointer;
        }
      }
    }
    .options:hover .options-icon{
      visibility: inherit;
    }s
  .avatar-uploader{
    position: relative;
    .icon-al-times-circle{
        position: absolute;
        left: 340px;
        bottom: 30px;
        cursor: pointer;
    }
  }
  .indemain {
    overflow: hidden !important;
  }
  .app-inner {
    padding: 0 !important;
  }
  .el-radio__input.is-checked + .el-radio__label {
    color: #36aafd !important;
  }
  .el-radio__input.is-checked .el-radio__inner {
    border-color: #36aafd;
    background: #36aafd;
  }
  .extracheck {
    .el-checkbox-group {
      .el-checkbox {
        display: block;
        margin-bottom: 20px;
      }
    }
  }
  .answer-group {
    .quillTemplate {
      margin-bottom: 80px;
    }
  }
  .el-upload-list__item-name {
    margin-bottom: 10px;
  }
  .editor {
    width: 100% !important;
    height: 150px !important;
  }
   .clozeClass{
    .ql-editor{
      p{
        display: inline-block !important;
      }
    }
  }
}
</style>